export default __webpack_public_path__ + "img/right3.9e34b981.jpg";